<template>
  <div id="app">
    <v-app>
      <!-- Navigation drawer for mobile screen -->
      <template v-if="appInitialied">
        <NavigationDrawer v-model="showDrawer" />
      </template>

      <Header v-if="appInitialied" @toggle-drawer="showDrawer = !showDrawer" />

      <!-- vue router -->
      <Banner style="position: sticky; top: 60px; z-index: 6" />

      <v-main class="body__background-color">
        <v-card
          v-if="appInitialied"
          flat
          tile
          width="100%"
          height="100%"
          class="pb-8"
          color="transparent"
        >
          <!-- Button to create subscription -->
          <v-btn
            v-if="showSubscibeBtn"
            fixed
            rounded
            large
            color="secondary"
            class="subscription-btn secondary-font-color text-capitalize pa-6 mt-2"
            @click.stop="onSubscribeBtnClick"
          >
            <span v-html="$translate('TAKE_SUBSCRIPTION_HTML')"></span>
          </v-btn>
          <router-view :key="$route.fullPath"></router-view>
        </v-card>
      </v-main>

      <CookieBar v-if="appInitialied" />

      <Footer v-if="appInitialied && !hideHeaderAndFooter" />

      <Account />
      <UserConfirmation />

      <!-- Snackbar -->
      <v-snackbar v-model="snackbar" :color="snackColor" timeout="10000">
        {{ snackText }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue darken-4"
            dark
            text
            class="text-capitalize"
            v-bind="attrs"
            @click="snackbar = false"
          >
            {{ $translate('CLOSE') }}
          </v-btn>
        </template>
      </v-snackbar>

      <GrowthVitaminDialog />

      <!-- error Dialog -->
      <v-dialog v-model="errorDialog" max-width="500" persistent>
        <v-card>
          <v-card-title class="text-break">
            {{ $translate('SOMETHING_WENT_WRONG') }}
          </v-card-title>
          <v-card-text v-text="errorText"></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="errorMultipleOptions"
              color="secondary"
              text
              @click="proceedAfterErrorDialog(1)"
            >
              {{ errorOption1 }}
            </v-btn>
            <v-btn
              v-if="errorMultipleOptions"
              color="primary"
              text
              @click="proceedAfterErrorDialog(2)"
            >
              {{ errorOption2 }}
            </v-btn>
            <v-btn
              v-if="!errorMultipleOptions"
              color="primary"
              text
              @click="errorDialog = false"
            >
              {{ $translate('CLOSE') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- shopping dialog -->
      <v-dialog v-model="shoppingDialog" max-width="500">
        <v-card class="pt-3">
          <v-card-text align="center" class="text-body-1">
            <div class="mb-3">
              <v-icon x-large color="success">mdi-check-circle</v-icon>
            </div>
            {{ $translate('ITEMS_ADDED_TO_BASKET') }}
          </v-card-text>
          <v-card-actions class="mx-2">
            <v-row class="ma-0">
              <v-btn
                block
                elevation="0"
                color="primary"
                class="mb-2 text-capitalize primary-font-color"
                @click="goToOrder()"
              >
                {{ $translate('GO_TO_SHOPPING_CART') }}
              </v-btn>
              <v-btn
                block
                elevation="0"
                color="secondary"
                class="mb-2 text-capitalize"
                @click="shoppingDialog = false"
              >
                {{ $translate('CONTINUE_SHOPPING') }}
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- shopping list dialog-->
      <v-dialog persistent v-model="shoppingListDialog" max-width="500">
        <v-card class="pt-3">
          <v-card-text
            align="center"
            v-if="action === 'added'"
            class="text-body-1"
          >
            <div class="mb-3">
              <v-icon x-large color="success">mdi-check-circle</v-icon>
            </div>
            {{ $translate('ITEMS_ADDED_TO_BASKET_FOR_SHOPPINGLIST') }}
            <span class="font-weight-bold">{{
              selectedShoppingList.ShoppingListName
            }}</span>
          </v-card-text>
          <v-card-text align="center" v-else class="text-body-1">
            <div class="mb-3">
              <v-icon x-large color="success">mdi-check-circle</v-icon>
            </div>
            {{ $translate('ITEMS_CHANGED_TO_BASKET_FOR_SHOPPINGLIST') }}
            <span class="font-weight-bold">{{
              selectedShoppingList.ShoppingListName
            }}</span>
          </v-card-text>
          <v-card-actions class="mx-2">
            <v-row class="ma-0">
              <v-btn
                v-if="action === 'added' || action === 'changed'"
                elevation="0"
                color="primary"
                class="mb-3 text-capitalize"
                block
                @click="goToShoppingList()"
              >
                {{ $translate('VIEW') }}
              </v-btn>
              <v-btn
                block
                elevation="0"
                color="secondary"
                class="mb-2 text-capitalize"
                @click="setDialogToFalse"
              >
                {{ $translate('CONTINUE_SHOPPING') }}
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app>
  </div>
</template>

<script>
import doRequest from '@/api/dssRequest';
import NetworkConnectionManager from '@/api/NetworkConnectionManager';
import utility from '@/shared/utility';
import UserObject from '@/objects/UserObject';
import Banner from '@/components/generalComponents/Banner';
import Header from '@/components/generalComponents/header/Header';
import Footer from '@/components/generalComponents/footer/Footer';
import Account from '@/components/account/Account';
import UserConfirmation from '@/components/booking/UserConfirmation';
import CookieBar from '@/components/CookieBar';
import GrowthVitaminDialog from '@/components/GrowthVitaminDialog';
import NavigationDrawer from '@/components/generalComponents/NavigationDrawer';
import appConfig from '../config/app_config';

export default {
  name: 'App',
  data() {
    return {
      // error dialog
      errorDialog: false,
      action: '',
      shoppingDialog: false,
      shoppingListDialog: false,
      errorText: '',
      errorMultipleOptions: false,
      errorOption1: '',
      errorOption2: '',
      proceedAfterErrorDialogData: {},
      proceedFunctionAfterErrorDialog: '',
      proceedFunctionName: '',
      activateObj: {},
      showBlock: false,
      message: 'loading content...',
      timeOut: null,
      timeLeft: 10,
      timer: null,

      snackText: '',
      snackColor: '',
      snackbar: false,

      growthData: {},
      growthDialog: false,

      partnerGroupLoaded: false,
      accountLoaded: false,
      languageLoaded: false,

      showDrawer: false,
    };
  },
  components: {
    Banner,
    Header,
    Footer,
    Account,
    UserConfirmation,
    CookieBar,
    GrowthVitaminDialog,
    NavigationDrawer,
  },
  computed: {
    currentEnvironment() {
      let enviromentStr = '';
      if (/^\d+$/.test(window.location.host.split('.')[1]) && appConfig.DEBUG) {
        enviromentStr = appConfig.partnerSubdomain;
      } else if (window.location.host.split('.')[1]) {
        [enviromentStr] = window.location.host.split('.');
      } else {
        enviromentStr = appConfig.partnerSubdomain;
      }

      return enviromentStr;
    },
    networkError() {
      const hasError = this.$store.getters.getNetworkError;
      if (hasError != null && hasError) {
        return true;
      }
      return false;
    },
    networkErrorRequest() {
      return this.$store.getters.getNetworkErrorRequest;
    },
    appInitialied() {
      if (this.partnerGroupLoaded) {
        return true;
      }
      return false;
    },
    hideHeaderAndFooter() {
      return this.$store.getters.getHideHeaderAndFooter;
    },
    userLoggedIn() {
      return this.$store.getters['auth/isValid'];
    },
    selectedShoppingList() {
      return this.$store.getters.getCurrentSelectedShoppingList;
    },
    partnerGroupDetails() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    showSubscibeBtn() {
      return (
        !this.hideHeaderAndFooter &&
        this.partnerGroupDetails != null &&
        this.partnerGroupDetails.ShowSubscriptionButton &&
        this.$route.name !== 'PartnerGroupSubscription' &&
        this.$route.name !== 'EventSubscription'
      );
    },
    shoppingListActive() {
      return this.$store.getters['shoppingList/active'];
    },
  },
  watch: {
    networkError() {
      if (this.networkError) {
        // Set timer to try reaching the backend again
        this.timeOut = setTimeout(this.getPartnerGroup, 10000);

        // Count down to show the user how much time is left
        clearInterval(this.timer);
        this.timeLeft = 10;
        this.timer = setInterval(() => {
          if (this.timeLeft > 0) {
            this.timeLeft -= 1;
          }
        }, 1000);
      } else {
        // to recall the starting calls
        this.init();
      }
    },
    partnerGroupLoaded() {
      if (this.partnerGroupLoaded) {
        this.getThemes();
        this.getAllLanguageTags();
        this.getAccountInfo();
        UserObject.getProductCategories();
      }
    },
  },
  created() {
    window.EventBus.listen('activateSnackBar', this.activateSnackBar);
    window.EventBus.listen('activateErrorDialog', this.activateErrorDialog);
    window.EventBus.listen('shoppingcartDialog', this.shoppingcartDialog);
    window.EventBus.listen('getShoppingLists', this.getShoppingLists);
    window.EventBus.listen('shoppinglistDialog', this.shoppinglistDialog);
    window.EventBus.listen('goToOrder', this.goToOrder);
    window.EventBus.listen('scrollToRightPosition', this.scrollToRightPosition);
    window.EventBus.listen('updateMetaData', this.updateMetaData);
    window.addEventListener('focus', this.onWindowGotFocus);
  },
  beforeDestroy() {
    window.EventBus.removeListener('activateSnackBar', this.activateSnackBar);
    window.EventBus.removeListener(
      'activateErrorDialog',
      this.activateErrorDialog
    );
    window.EventBus.removeListener(
      'shoppingcartDialog',
      this.shoppingcartDialog
    );
    window.EventBus.removeListener(
      'shoppinglistDialog',
      this.shoppinglistDialog
    );
    window.EventBus.removeListener('getShoppingLists', this.getShoppingLists);
    window.EventBus.removeListener('goToOrder', this.goToOrder);
    window.EventBus.removeListener(
      'scrollToRightPosition',
      this.scrollToRightPosition
    );
    window.EventBus.removeListener('updateMetaData', this.updateMetaData);
    window.removeEventListener('focus', this.onWindowGotFocus);
  },
  mounted() {
    // Check bandwidth
    NetworkConnectionManager.checkBandwidth();

    // Storing the tmpUserId if tmpUserId is empty
    if (this.$store.getters['auth/tmpUserId'] === '') {
      this.$store.commit('auth/setTmpUserId', this.makeTmpUserId(16));
      // scroll position is banner
      this.$store.commit('setScrollDirectlyToItems', false);
    }
    this.init();
  },
  metaInfo() {
    return {};
  },
  methods: {
    /**
     * generic function to scroll to the right position after a route
     * @param element (needs to be an id with #)
     */
    scrollToRightPosition(element) {
      // scroll to the right position on that page
      this.$vuetify.goTo(element);
    },
    updateMetaData(payload) {
      // set the title template
      this.$metaInfo.titleTemplate = `%s ${this.$store.getters['Account/partnerGroupDetails'].PartnerGroupDisplayName}`;
      // set the title
      this.$metaInfo.title = payload.Title ? `${payload.Title} |` : '';

      let keywords = '';

      if (
        this.$store.getters['Account/metaData'].KeyWords !== payload.KeyWords
      ) {
        if (payload.KeyWords.length) {
          keywords =
            payload.KeyWords.join(', ') +
            ', ' +
            this.$store.getters['Account/metaData'].KeyWords.join(', ');
        } else {
          keywords =
            this.$store.getters['Account/metaData'].KeyWords.join(', ');
        }
      } else {
        keywords = payload.KeyWords.join(', ');
      }

      this.$metaInfo.meta = [
        {
          name: 'keywords',
          content: keywords,
        },
        {
          name: 'description',
          content: payload.Description,
        },
        {
          name: 'google-site-verification',
          content:
            this.$store.getters['Account/metaData'].GoogleSiteVerification,
        },
      ];

      let pgName = this.$store.getters['Account/partnerGroupDetails'].PartnerGroupName
      if (pgName === 'www') {
        this.$metaInfo.link = [
          {
            rel: 'icon', type: 'image/png', sizes: '32x32', href: 'https://images.superlinda.nl/images/BuyFresh%2032.png',
          },
          {
            rel: 'icon', type: 'image/png', sizes: '16x16', href: 'https://images.superlinda.nl/images/BuyFresh%2016.png',
          },
          // {
          //   rel: 'shortcut icon', href: 'https://www.bol.com/favicon.ico',
          // },
        ];
      } else {
        this.$metaInfo.link = [
          {
            rel: 'icon', type: 'image/png', sizes: '32x32', href: 'https://images.superlinda.nl/images/Transparent%2032.png',
          },
          {
            rel: 'icon', type: 'image/png', sizes: '16x16', href: 'https://images.superlinda.nl/images/Transparent%2016.png',
          },
          // {
          //   rel: 'shortcut icon', href: 'https://www.bol.com/favicon.ico',
          // },
          ];
      }

      this.$meta().refresh();
    },
    setDialogToFalse() {
      this.shoppingListDialog = false;
      if (this.action === 'changed') {
        window.EventBus.fire('getShoppingLists');
      }
    },
    // Function to open dialog when you add something to you shopping cart
    shoppingcartDialog() {
      this.shoppingDialog = true;
    },
    shoppinglistDialog(action) {
      this.action = '';
      this.action = action;
      this.shoppingListDialog = true;
    },
    goToShoppingList() {
      this.shoppingListDialog = false;
      window.EventBus.fire('openShoppingListDialog', true);
    },
    goToOrder() {
      this.shoppingDialog = false;
      this.$router.push({
        name: 'Booking',
      });
    },
    makeTmpUserId(length) {
      const randomStr = utility.getRandomString(
        length,
        true,
        true,
        true,
        false
      );
      return `TMP_${randomStr}`;
    },
    init() {
      this.getPartnerGroup();
      this.getPopup();
      this.initFacebookSDK();
      this.initAppleAuth();
    },
    getPopup() {
      // dont show popup on homepage
      if (window.location.pathname === '/' || window.location.pathname === '') {
        return;
      }
      let getPopupCall = () => {
        const payload = {};

        const object = this.$store.getters['auth/userName']
          ? this.$store.getters['auth/userName']
          : this.$store.getters['auth/tmpUserId'];

        doRequest(
          (response) => {
            if (response.data.GrowthVitamin != null) {
              this.$store.commit(
                'addGrowthVitamin',
                response.data.GrowthVitamin
              );
              window.EventBus.fire(
                'activateGrowthDialog',
                response.data.GrowthVitamin
              );
            }
          },
          () => {},
          'getPopUp',
          object,
          payload
        );
      };
      setTimeout(() => {
        getPopupCall();
      }, 10000);
    },
    initFacebookSDK() {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: '1816135695195986',
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v8.0',
        });
        window.FB.AppEvents.logPageView();
      };

      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = '//connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    },
    initAppleAuth() {
      let redirect = `${window.location.protocol}//${window.location.hostname}`;
      if (window.location.port) {
        redirect = `${redirect}:${window.location.port}`;
      }

      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src =
          '//appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'appleAuth');

      setTimeout(() => {
        window.AppleID.auth.init({
          clientId: 'nl.Trinite-Soft-BV.Signin',
          scope: 'email',
          redirectURI: redirect,
          usePopup: true,
          state: '3/.3hZ8@A&x?_xh4@-[2GpL[mr.{nt',
        });
      }, 2000);
    },
    activateSnackBar(payload) {
      if (typeof payload === 'object') {
        this.snackText = payload.text;
        this.snackColor = payload.color;
      } else {
        this.snackText = payload;
        this.snackColor = 'info';
      }

      this.snackbar = true;
    },
    activateErrorDialog(
      errorText,
      multipleOptionsBoolean,
      errorOption1,
      errorOption2,
      returnData,
      proceedFunction,
      functionName
    ) {
      this.errorText = errorText;
      this.errorDialog = true;
      if (multipleOptionsBoolean) {
        // Dialog will contain a possibility for the user to pick
        this.errorMultipleOptions = true;
        this.errorOption1 = errorOption1;
        this.errorOption2 = errorOption2;
        this.proceedAfterErrorDialogData = returnData;
        this.proceedFunctionAfterErrorDialog = proceedFunction;
        this.proceedFunctionName = functionName;
      }
    },
    proceedAfterErrorDialog(userPick) {
      this.errorDialog = false;
      window.EventBus.fire(
        this.proceedFunctionAfterErrorDialog,
        userPick,
        this.proceedAfterErrorDialogData,
        this.proceedFunctionName
      );
    },
    getPartnerGroup() {
      this.$store.commit('setNetworkError', false);
      this.$store.commit('setNetworkErrorRequest', '');
      this.$store.commit('setPartnerGroupUrl', this.currentEnvironment);

      const payload = {
        Url: this.currentEnvironment,
      };

      doRequest(
        (response) => {
          // check if the user is changed from enviroment
          if (
            this.$store.getters['auth/partnerGroup'] !==
            response.data.Environment
          ) {
            this.$store.commit('shoppingCart/setOrders', []);
            // Making sure that the shoppingList is not transported.
            if (this.userLoggedIn) {
              this.getShoppingLists();
            } else {
              this.$store.commit('shoppingList/setOrders', []);
            }
          }

          this.$store.commit('auth/setPartnerGroup', response.data.Environment);
          this.$store.commit('Account/setPartnerGroupDetails', response.data);

          // check for the main partnerId
          const mainPartner = response.data.Partners.find(
            (partner) => partner.MainPartner
          );

          if (mainPartner != null) {
            this.$store.commit('auth/setMainPartnerId', mainPartner.PartnerId);
          }

          if (response.data.MetaData != null) {
            this.$store.commit('Account/setMetaData', response.data.MetaData);
            this.updateMetaData(response.data.MetaData);
          }

          // storing the partners within the partnerGroup
          this.$store.commit(
            'setPartnersFromPartnerGroup',
            response.data.Partners
          );

          // Setting the light theme colors
          this.$vuetify.theme.themes.light.primary = response.data.PrimaryColor;
          this.$vuetify.theme.themes.light.secondary =
            response.data.SecondaryColor;
          this.updateTheme(response.data);

          // Update Geoapify API info
          if (response.data.GeoApifyInfo != null) {
            this.$store.commit(
              'Account/setGeoApifyInfo',
              response.data.GeoApifyInfo
            );
          }

          this.partnerGroupLoaded = true;

          if (this.userLoggedIn) {
            // to create the user with his newest data when entering the page
            const user = new UserObject();
            user.getUserData();
          }
        },
        (error) => {
          if (error.data != null && error.data.ErrorCode != null) {
            if (error.data.ErrorCode === 'E_PG_001') {
              window.EventBus.fire(
                'activateSnackBar',
                this.$translate('PARTNER_DOESNT_EXIST')
              );
            }
          }
        },
        'getPartnerGroup',
        'LocationsNode_PGSE',
        payload,
        'GET'
      );
    },
    getShoppingLists() {
      if (!this.userLoggedIn) {
        return;
      }
      const userId = this.$store.getters['auth/userName'];
      const payload = {};
      doRequest(
        (response) => {
          let lists = [];
          if (response.data.ShoppingLists != null) {
            lists = response.data.ShoppingLists;
          }

          if (lists == null || lists.length === 0) {
            this.$store.commit('setCurrentSelectedShoppingList', {});
          }

          this.$store.commit('shoppingList/setOrders', lists);
        },
        () => {},
        'getShoppingLists',
        userId,
        payload
      );
    },
    getAccountInfo() {
      this.$store.commit('setNetworkError', false);
      this.$store.commit('setNetworkErrorRequest', '');
      this.accountLoaded = false;
      const payload = {
        Region: '',
      };
      doRequest(
        (response) => {
          const currentAccountInfo = utility.createArrayWithObjects(
            response.data.Account
          )[0];
          const accountPreferencesArray = utility.createArrayWithObjects(
            response.data.AccountInfo
          );
          const currentAccountPreferences = {};
          accountPreferencesArray.forEach((preference) => {
            currentAccountPreferences[preference.Key] = preference.Value;
          });

          // Storing the account information in the store
          this.$store.commit('Account/setAccountInformation', {
            AccountId: currentAccountInfo.AccountId,
            AccountName: currentAccountInfo.AccountName,
            AccountLogo: currentAccountPreferences.Header_logo,
            AccountUrl: currentAccountPreferences.information_page,
          });

          this.$store.commit(
            'Account/setPrivacyStatement',
            response.data.Translations.PrivacyStatement
          );
          this.$store.commit(
            'Account/setTranslations',
            response.data.Translations
          );

          this.accountLoaded = true;
        },
        () => {
          this.$store.commit('Account/setTranslations', {});
        },
        'getAccountInfo',
        appConfig.dss.accountManagerObjectId,
        payload,
        'GET'
      );
    },
    checkUserLoggedInEnv(accountId) {
      // logs the user out if the user goes to another environment
      if (
        this.$store.getters['auth/userEnv'] !== '' &&
        this.$store.getters['auth/userEnv'] !== accountId
      ) {
        UserObject.logout();

        this.$router.push({
          name: 'Homepage',
          params: {
            account_id: this.$store.getters.getRegion,
          },
        });
      }
    },
    getAllLanguageTags() {
      // Retrieving the possible languages
      const accountId =
        this.$store.getters['Account/partnerGroupDetails'].AccountId;
      if (accountId == null || accountId === '') {
        return;
      }

      this.languageLoaded = false;
      const payload = {
        PartnerGroupId:
          this.$store.getters['Account/partnerGroupDetails'].PartnerGroupId,
      };
      doRequest(
        (response) => {
          response.data.Languages.forEach((lang) => {
            switch (lang.EnglishName) {
              case 'English':
                lang.shortName = 'EN';
                break;
              case 'German':
                lang.shortName = 'DE';
                break;
              case 'Dutch':
                lang.shortName = 'NL';
                break;
              default:
                break;
            }
          });

          this.$store.commit('setAllLanguages', response.data.Languages);

          const userLanguage = this.$store.getters['auth/userLanguage'];

          if (!this.userLoggedIn && Object.keys(userLanguage).length === 0) {
            const defaultLan = response.data.Languages.find(
              (lan) => lan.EnglishName === 'Dutch'
            );
            this.$store.commit('auth/setUserLanguage', defaultLan);
          }

          this.languageLoaded = true;
        },
        () => {},
        'getAllLanguageTags',
        accountId,
        payload,
        'GET'
      );
    },
    updateTheme(partnerGroupInfo) {
      const selector = document.querySelector(':root');
      if (
        partnerGroupInfo.PrimaryColor != null &&
        partnerGroupInfo.PrimaryColor.trim() !== ''
      ) {
        selector.style.setProperty(
          '--primary-color',
          partnerGroupInfo.PrimaryColor
        );
      }
      if (
        partnerGroupInfo.SecondaryColor != null &&
        partnerGroupInfo.SecondaryColor.trim() !== ''
      ) {
        selector.style.setProperty(
          '--secondary-color-opacity',
          `${partnerGroupInfo.SecondaryColor}1A`
        );
      }
      if (partnerGroupInfo.PrimaryFontColor != null) {
        selector.style.setProperty(
          '--primary-font-color',
          partnerGroupInfo.PrimaryFontColor
        );
      }
      if (partnerGroupInfo.SecondaryFontColor != null) {
        selector.style.setProperty(
          '--secondary-font-color',
          partnerGroupInfo.SecondaryFontColor
        );
      }
    },
    getThemes() {
      doRequest(
        (response) => {
          let themes = [];
          if (response.data.Events != null) {
            themes = [...response.data.Events];
          }

          this.$store.commit('Account/setThemes', themes);
        },
        () => {},
        'getThemes',
        'LocationsNode_ESE',
        {},
        'GET'
      );
    },
    onSubscribeBtnClick() {
      const shoppingLists = this.$store.getters['shoppingList/orders'];
      let subscription = null;

      if (shoppingLists != null && shoppingLists.length > 0) {
        subscription = shoppingLists.find(
          (list) => list.Type === 'Subscription'
        );
      }

      if (subscription != null && this.userLoggedIn) {
        // Already have a subscription, redirect to subscription page if shopping list
        // page is not active. Otherwise continue to subscription page.
        if (this.shoppingListActive) {
          window.EventBus.fire('openShoppingListDialog', false);
          this.goToSubscription();
        } else {
          this.$store.commit('setCurrentSelectedShoppingList', subscription);
          this.goToShoppingList();
        }
      } else {
        // No subscription yet, redirect to creation page
        if (this.shoppingListActive) {
          window.EventBus.fire('openShoppingListDialog', false);
        }
        this.goToSubscription();
      }
    },
    goToSubscription() {
      this.$router.push({
        name: 'PartnerGroupSubscription',
      });
    },
    onWindowGotFocus() {
      // Check bandwidth when user focused on the window, e.g. user changed to another tab and comes back later
      NetworkConnectionManager.checkBandwidth();
    },
  },
};
</script>

<style>
:root {
  --primary-color: rgb(0, 230, 118);
  --secondary-color-opacity: #ffffff;
  --primary-font-color: #ffffff;
  --secondary-font-color: #ffffff;
}
* {
  /* font-family: "HelveticaNeue", "Helvetica"; */
  font-family: Roboto, 'Helvetica Neue', Helvetica;
}
.body__background-color {
  background-color: var(--secondary-color-opacity) !important;
}
.white-space-pre-line {
  white-space: pre-line;
}
.subscription-btn {
  right: 5px;
  z-index: 5;
}
.primary-font-color {
  color: var(--primary-font-color) !important;
}
.secondary-font-color {
  color: var(--secondary-font-color) !important;
}
.background-color--primary {
  background-color: var(--primary-color);
}
.v-btn {
  text-transform: none !important;
}
</style>
